import React, { useEffect, useState } from "react";
import { ReportAbuseLoadingDialog } from "./reportAbuse-loading-dialog/ReportAbuseLoadingDialog";
import { ReportAbuseReceiptModal } from "./reportAbuse-receipt-modal/ReportAbuseReceiptModal";
import { ReportAbuseCard } from "./ReportAbuseCard";
import { ReportAbuseUIProvider } from "./ReportAbuseUIContext";
import { ReportAbuseDeleteModal } from "./reportAbuse-delete-modal/ReportAbuseDeleteModal";
import UpdatedSuccessfulModal from "../Modal/UpdatedSuccessfulModal";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { isUnauthorized } from "../../utils/utils";
import {
  deleteReportAbuseApi,
  // addReportAbuseApi,
  reportAbuseListApi,
  // deleteReportAbuseApi,
  // editReportAbuseApi,
} from "../../../axios/services/services";
import ErrorModal from "../Modal/ErrorModal";
import { initialFilter } from "./ReportAbuseUIHelpers";

export function ReportAbusePage({ history }) {
  const [isLoadingDeleteReportAbuse, setLoadingDeleteReportAbuse] = useState(
    false
  );

  const [isConfirmModal, setConfirmModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [data, setData] = useState({});
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [reportAbuseList, setReportAbuseList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [reportAbuseListTotalCount, setReportAbuseListTotalCount] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const reportAbuseUIEvents = {
    openReceiptDialog: (row) => {
      setData(row);
      handleConfirmShow();
    },
    openDeleteDialog: (row) => {
      setData(row);
      handleDeleteShow();
    },
  };

  useEffect(() => {
    async function getReportAbuseList() {
      enableLoading();
      const reportAbuseListResponse = await reportAbuseListApi({
        filterValues,
        queryParams,
      });
      disableLoading();
      if (reportAbuseListResponse.Error) {
        isUnauthorized({ response: reportAbuseListResponse });
        setErrorMessage(reportAbuseListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setReportAbuseListTotalCount(
        reportAbuseListResponse && reportAbuseListResponse.count
          ? reportAbuseListResponse.count
          : 0
      );
      setReportAbuseList(
        reportAbuseListResponse && reportAbuseListResponse.data
          ? reportAbuseListResponse.data
          : []
      );
    }
    getReportAbuseList();
  }, [filterValues, queryParams]);

  const handleDeleteReportAbuse = () => {
    deleteReportAbuse();
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const deleteReportAbuse = async () => {
    const { id } = data;
    enableLoadingDeleteReportAbuse();
    const deleteReportAbuseResponse = await deleteReportAbuseApi({ id });
    disableLoadingDeleteReportAbuse();
    if (deleteReportAbuseResponse.Error) {
      isUnauthorized({ response: deleteReportAbuseResponse });
      setErrorMessage(deleteReportAbuseResponse.Error.message);
      handleErrorModalShow();
      return;
    }
    setSuccessMessage(`Record Deleted Successfully`);
    handleSuccessModalShow();
    handleDeleteHide();
  };

  const enableLoadingDeleteReportAbuse = () => {
    setLoadingDeleteReportAbuse(true);
  };

  const disableLoadingDeleteReportAbuse = () => {
    setLoadingDeleteReportAbuse(false);
  };

  const handleConfirmShow = () => {
    setConfirmModal(true);
  };

  const handleConfirmHide = () => {
    setConfirmModal(false);
  };

  const handleDeleteShow = () => {
    setDeleteModal(true);
  };

  const handleDeleteHide = () => {
    setDeleteModal(false);
  };

  const handleSuccessModalShow = () => {
    setIsSuccessModalOpen(true);
  };

  const handleSuccessModalHide = () => {
    setIsSuccessModalOpen(false);
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  const handleFilterValues = (values) => {
    setFilterValues(values);
  };

  const handleSetCurrentPage = (currentPage) => {
    setCurrentPage(currentPage);
  };

  return (
    <ReportAbuseUIProvider
      reportAbuseUIEvents={reportAbuseUIEvents}
      queryParams={queryParams}
      setQueryParamsBase={setQueryParamsBase}
      ids={ids}
      setIds={setIds}
    >
      <ReportAbuseLoadingDialog />

      {isConfirmModal && (
        <ReportAbuseReceiptModal
          data={data}
          handleConfirmHide={handleConfirmHide}
          isConfirmModal={isConfirmModal}
        />
      )}

      {isDeleteModal && (
        <ReportAbuseDeleteModal
          isLoadingDeleteReportAbuse={isLoadingDeleteReportAbuse}
          data={data}
          onClickOfSaveButton={handleDeleteReportAbuse}
          handleDeleteHide={handleDeleteHide}
          isDeleteModal={isDeleteModal}
        />
      )}

      <ReportAbuseCard
        isLoading={isLoading}
        filterValues={filterValues}
        handleFilterValues={handleFilterValues}
        // handleAddReportAbuseShow={handleAddReportAbuseShow}
        reportAbuseListTotalCount={reportAbuseListTotalCount}
        currentPage={currentPage}
        setCurrentPage={handleSetCurrentPage}
        reportAbuseList={reportAbuseList}
      />

      <UpdatedSuccessfulModal
        message={successMessage}
        UpdatedSuccessfulModalShow={isSuccessModalOpen}
        UpdatedSuccessfulModalHide={handleSuccessModalHide}
        successIcon={
          <div className="success-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
              />
            </span>
          </div>
        }
      />

      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </ReportAbuseUIProvider>
  );
}
